<ng-container *ngIf="is_loading">
  <mat-progress-bar color="accent" mode="indeterminate"></mat-progress-bar>
</ng-container>
<div
  *ngIf="!is_loading && dirPay === 'false' && !showAdvancedOptionsPage"
  class="make-payment"
>
  <div class="nav-header">
    <i></i>
    <h2>Secure Payment</h2>
    <i class="healent-secure"></i>
  </div>
  <div class="m-t-header p-h-l d-flex gap flex-direction-column">
    <h1 class="payment-title redColor">Let's Make The Required Payment!</h1>
    <p class="make-payment-description">
      Here is the payment step which allows you to easily pay your outstanding
      balance and the copayment for your visit.
    </p>
  </div>
  <div class="balance-card m-t-l p-h-l">
    <h2 class="balance-card-title">Your balance</h2>

    <div class="balance-item">
      <span class="item-label">Outstanding balance</span>
      <span class="item-value">{{ displayOutstandingBalance }}</span>
    </div>

    <div class="balance-item">
      <span class="item-label">Copay for this visit</span>
      <span class="item-value">{{ displayCopayAmount }}</span>
    </div>

    <hr class="divider" />

    <div class="balance-total">
      <span class="total-label">Total</span>
      <span class="total-value">{{ displayTotalBalanceCard }}</span>
    </div>
  </div>

  <div class="payment-options-container">
    <h2 class="section-title">How To Pay?</h2>
    <p class="section-subtitle">
      Choose the preferred method to pay the due amount
    </p>

    <mat-radio-group [(ngModel)]="selectedCard" name="paymentMethod">
      <app-radio-card
        *ngFor="let card of cardsList"
        [value]="card.id"
        [isSelected]="selectedCard === card.id"
        [contentTemplate]="cardListContent"
        customClasses="cardList-option"
        (cardClick)="onCardSelect($event)"
        [isExpanded]="selectedCard === card.id && selectedCard !== 'newCard'"
        [expandedTemplate]="
          selectedCard === card.id && selectedCard !== 'newCard'
            ? savedCardCvvTemplate
            : null
        "
      >
        <ng-template #cardListContent>
          <div class="radio-label-wrapper">
            <div class="radio-button-section">
              <p
                class="card-main-label"
                [ngClass]="{ 'new-card-label': card.isNew }"
              >
                {{ card.bankName }}
              </p>
            </div>

            <div class="card-details-section">
              <p class="card-sub-label">
                {{ card.isNew ? '' : card.maskedNumber }}
              </p>
              <div class="card-icons">
                <img
                  *ngIf="card.type === 'visa' || card.type === 'new'"
                  src="assets/icons/Visa.svg"
                  alt="Visa"
                />
                <img
                  *ngIf="card.type === 'mastercard' || card.type === 'new'"
                  src="assets/icons/Mastercard.svg"
                  alt="Mastercard"
                />
                <img
                  *ngIf="card.type === 'amex' || card.type === 'new'"
                  src="assets/icons/AMEX.svg"
                  alt="American Express"
                />
                <img
                  *ngIf="card.type === 'discover' || card.type === 'new'"
                  src="assets/icons/Discover.svg"
                  alt="Discover"
                />
                <img
                  *ngIf="card.type === 'applePay'"
                  src="assets/icons/ApplePay.svg"
                  alt="Apple Pay"
                />
                <img
                  *ngIf="card.type === 'googlePay'"
                  src="assets/icons/GooglePay.svg"
                  alt="Google Pay"
                />
              </div>
            </div>
          </div>
        </ng-template>
        <ng-template #savedCardCvvTemplate>
          <div class="partial-amount-panel" [formGroup]="savedCardCvvForm">
            <div class="form-field-wrapper">
              <label for="savedCardCvv" class="input-label"
                >Security code</label
              >
              <input
                matInput
                type="text"
                id="savedCardCvv"
                formControlName="cvv"
                [placeholder]="
                  selectedSavedCardType === 'amex'
                    ? 'Enter CVV XXXX'
                    : 'Enter CVV XXX'
                "
                [maxlength]="selectedSavedCardType === 'amex' ? 4 : 3"
                [ngClass]="{ 'error-border': showInputError['cvv'] }"
                (input)="onCvvInput()"
              />
              <div
                class="warning-message"
                *ngIf="
                  savedCardCvvForm.get('cvv')?.invalid &&
                  (savedCardCvvForm.get('cvv')?.dirty ||
                    savedCardCvvForm.get('cvv')?.touched)
                "
              >
                <span *ngIf="savedCardCvvForm.get('cvv')?.errors?.['required']"
                  >Security code is required.</span
                >
                <span
                  *ngIf="
                    selectedSavedCardType === 'amex' &&
                    savedCardCvvForm.get('cvv')?.value?.length !== 4
                  "
                  >American Express security code must be 4 digits.</span
                >
                <span
                  *ngIf="
                    selectedSavedCardType !== 'amex' &&
                    selectedSavedCardType &&
                    savedCardCvvForm.get('cvv')?.value?.length !== 3
                  "
                  >Security code must be 3 digits.</span
                >
              </div>
            </div>
          </div>
        </ng-template>
      </app-radio-card>
    </mat-radio-group>
  </div>

  <div class="payment-options-container" style="margin-top: 32px">
    <h2 class="section-title">Payment Options</h2>
    <p class="section-subtitle">
      Choose one of the following payment options to process the payment
    </p>

    <mat-radio-group
      [(ngModel)]="selectedPaymentOptionId"
      name="paymentOptionGroup"
      (change)="onOptionSelect($event.value)"
    >
      <app-radio-card
        *ngFor="let option of paymentOptions"
        [value]="option.id"
        [isSelected]="selectedPaymentOptionId === option.id"
        [isExpanded]="
          option.id === 'partial' && selectedPaymentOptionId === 'partial'
        "
        [contentTemplate]="paymentOptionContent"
        [expandedTemplate]="
          option.id === 'partial' ? partialAmountTemplate : null
        "
        customClasses="payment-option-card"
        (cardClick)="onOptionSelect($event)"
      >
        <ng-template #paymentOptionContent>
          <div class="radio-label-wrapper">
            <span class="option-label">{{ option.label }}</span>
            <span class="option-amount" *ngIf="option.amount !== undefined">{{
              option.amount | currency
            }}</span>
          </div>
        </ng-template>

        <ng-template #partialAmountTemplate>
          <div class="partial-amount-panel" [formGroup]="partialAmountForm">
            <div class="form-field-wrapper">
              <label for="partialAmount" class="input-label"
                >Amount to pay</label
              >
              <input
                #partialAmountInput
                matInput
                type="text"
                id="partialAmount"
                formControlName="partialAmount"
                (input)="onPartialAmountInput($event)"
                (blur)="onPartialAmountBlur()"
                placeholder="$0.00"
                [ngClass]="{ 'error-border': showInputError['partialAmount'] }"
              />
              <div
                *ngIf="
                  partialAmountForm.get('partialAmount')?.invalid &&
                  (partialAmountForm.get('partialAmount')?.dirty ||
                    partialAmountForm.get('partialAmount')?.touched)
                "
                class="warning-message"
              >
                <span
                  *ngIf="partialAmountForm.get('partialAmount')?.errors?.['required']"
                  class=""
                  >Amount is required.</span
                >
                <span
                  *ngIf="partialAmountForm.get('partialAmount')?.errors?.['min']"
                  >Minimum Amount: {{ minPartialAmount | currency }}</span
                >
                <span
                  *ngIf="partialAmountForm.get('partialAmount')?.errors?.['max']"
                  >Maximum Amount: {{ balance | currency }}</span
                >
              </div>
            </div>
          </div>
        </ng-template>
      </app-radio-card>
    </mat-radio-group>

    <div class="payment-actions-wrapper">
      <button
        class="common-action-button pay-now-color"
        [ngClass]="{ 'loading': isPayNowLoading }"
        [disabled]="isPayNowLoading"
        (click)="onPayNowClick()"
      >
        <span *ngIf="isPayNowLoading" class="spinner"></span>
        {{ getPayNowButtonText() }}
        <i *ngIf="!isPayNowLoading" [ngClass]="'healent-path-2519'"></i>
      </button>
      
      <div *ngIf="showSkipButton && !isReactNative" class="pay-a" style="margin-top: 16px;">
        <span 
          (click)="skipDirect()" 
          [ngClass]="{ 'skip-loading': isSkipDirectLoading }"
          [style.pointer-events]="isSkipDirectLoading ? 'none' : 'auto'"
          style="color: var(--primary-color); cursor: pointer; display: flex; align-items: center; gap: 8px;"
        >
          <span *ngIf="isSkipDirectLoading" class="spinner"></span>
          Skip
        </span>
      </div>
      <p class="payment-secure">
        {{ friendlyProviderText }}
        <span class="greenColor">Secure</span> Payment
      </p>
      <img src="../../assets/icons/SecureIcons.svg" alt="" class="secure-img" />
      <div style="margin-top: 32px">
        <h2 class="secure-title redColor">Have An Issue?</h2>
        <p class="section-subtitle">
          Press the following button if you have an issue completing the payment
        </p>
      </div>
      <button
        class="common-action-button advanced-options-color"
        (click)="toggleAdvancedOptions()"
      >
        See Advanced Options
        <i [ngClass]="'healent-path-2519'" class="color-prim"></i>
      </button>
    </div>
  </div>

  <!-- <div class="p-h-l">
    <h3
      class="payment-balance"
      [ngClass]="{
        redColor: currentBalance > 0,
        greenColor: currentBalance <= 0
      }"
    >
      Current balance: {{ currentBalance | currency: 'USD':true:'1.2-2' }}
    </h3>
    <h1 class="payment-title">Payment Details</h1>
  </div>
  <div class="m-t-l p-h-l">
    <h3 class="Amount-to-pay">Amount to pay</h3>
    <mat-form-field appearance="fill">
      <input
        matInput
        placeholder="$0.00"
        [(ngModel)]="amountToPay"
        (input)="handleInputAmountChange($event)"
        (blur)="handleInputBlur()"
        type="text"
      />
      <mat-error style="font-size: 12px" *ngIf="isInvalidAmount()">
        Please enter a valid amount
      </mat-error>
    </mat-form-field>

    <h3
      class="payment-balance text-center p-b-m"
      [ngClass]="{
        redColor: remainingBalance > 0,
        greenColor: remainingBalance <= 0
      }"
    >
      Remaining Balance: {{ remainingBalance | currency: 'USD':true:'1.2-2' }}
    </h3>
  </div>
  <div class="flex-container">
    <button class="pay-btn" (click)="proceedToPayment()">
      <span>Proceed To Payment</span>
    </button>
    <button class="skip-btn" (click)="skip()">
      <span>Skip</span>
    </button>
  </div> -->
</div>

<div
  *ngIf="!is_loading && showAdvancedOptionsPage"
  class="advanced-options-screen"
>
  <div class="nav-header">
    <i (click)="goBackFromAdvancedOptions()" class="healent-back color-w"></i>
    <h2>Advanced Options</h2>
    <i class="healent-secure"></i>
  </div>

  <div class="m-t-header p-h-l">
    <div class="payment-title">Advanced Options</div>
    <div class="advanced-options-subtitle">
      Having trouble with your payment? Choose an option below.
    </div>
  </div>

  <div class="advanced-options-page-buttons-wrapper">
    <a
      class="advanced-option-action-button a-btn"
      [href]="getSupportPhoneNumber()"
      (click)="openDialer($event)"
      [class.disabled]="isSkipPaymentLoading"
      [style.pointer-events]="isSkipPaymentLoading ? 'none' : 'auto'"
    >
      <i [ngClass]="'healent-form-input-icon-28'"></i> Call Support
    </a>

    <button
      class="advanced-option-action-button"
      (click)="skip()"
      [disabled]="isSkipPaymentLoading"
    >
      <span *ngIf="isSkipPaymentLoading" class="spinner"></span>
      <i *ngIf="!isSkipPaymentLoading" [ngClass]="'healent-group-3111'"></i>
      {{ isSkipPaymentLoading ? 'Processing...' : 'Pay at Front Desk' }}
    </button>
    
    <div *ngIf="skipPaymentError" class="skip-payment-error">
      {{ skipPaymentError }}
    </div>
  </div>

  <div class="flex-container" style="margin-top: 20px"></div>
</div>

<div *ngIf="!is_loading && dirPay === 'true'">
  <div class="nav-header">
    <i (click)="goBackToPaymentOptions()" class="healent-back color-w"></i>
    <h2>Add A New Card</h2>
    <i class="healent-secure"></i>
  </div>

  <div class="m-t-header p-l-r-l">
    <h3 class="payment-balance">
      {{ payNowButtonAmount | currency: 'USD':true:'1.2-2' }}
    </h3>
    <h1 class="payment-title pay-t">Pay Via A New Card</h1>
  </div>
  <form [formGroup]="myForm" (ngSubmit)="onSubmit()" novalidate>
    <div>
      <app-card-details
        [nameOnCard]="getFormControl('nameoncard')"
        [accountnumber]="getFormControl('accountnumber')"
        [expirationDate]="getFormControl('expirationDate')"
        [securityCode]="getFormControl('cardsecuritycode')"
        (cardDetailsUpdated)="onCardDetailsUpdated($event)"
      ></app-card-details>

      <h3 class="card-address">Billing Address</h3>
      <div class="card-details">
        <app-address
          [formGroup]="myForm"
          [required]="true"
          (addressUpdated)="onAddressUpdated($event)"
        ></app-address>
      </div>
      <div class="save-details-checkbox">
        <mat-checkbox formControlName="saveCardDetails" disabledInteractive="">
          Store Your Card On File For Hassle-Free Payments In The Future
        </mat-checkbox>
      </div>
      <p class="card-details-text">
        Securely store your card for future payments for quick and easy progress
        without the hassle of entering all these details again.
      </p>
      <div class="flex-container" style="margin-bottom: 48px">
        <button
          [disabled]="is_loading || isSubmitting"
          type="submit"
          class="pay-btn"
        >
          <span *ngIf="isSubmitting" class="spinner"></span>
          <span *ngIf="isSubmitting">Processing...</span>
          <span *ngIf="!isSubmitting"
            >Pay Now ({{
              payNowButtonAmount | currency: 'USD':true:'1.2-2'
            }}) </span
          ><i *ngIf="!isSubmitting" [ngClass]="'healent-path-2519'"></i>
        </button>

        <div *ngIf="showSkipButton && !isReactNative" class="pay-a">
          <span (click)="skip()">Skip</span>
        </div>
        <!--         <div
          *ngIf="!isReactNative"
          class="pay-a"
          (click)="goBackToPaymentOptions()"
        >
          <span>Back</span>
        </div> -->

        <span *ngIf="errorMessage" class="alert alert-danger">
          {{ errorMessage }}
        </span>
      </div>
    </div>
  </form>
</div>
